import React from "react";
import { ReactComponent as Logo } from "../../components/logo.svg";
import classes from "./LoadingPage.module.scss";

export const LoadingPage = () => {
  return (
    <div className={classes.loadingContainer} data-testid="loading-logo">
      <Logo className={classes.logo}/>
    </div>
  );
};
